import Enum from 'enum';

const accountStatus = new Enum(['NotFound', 'ContinueRegistrationRequired', 'Ok'], {
  name: 'AccountStatus',
  freez: true,
  ignoreCase: true,
});

export default accountStatus;
